import { toastService } from "src/libraries/toast";
import { getFeaturesUseCase } from "./getFeaturesUseCase";
import { UpdateFeaturesDto } from "../entity/features/dto/update-features-dto";
import { featuresService } from "../entity/features/FeaturesService";
import { featuresModel } from "../entity/features/FeaturesModel";

export const updateFeaturesUseCase = async (body: UpdateFeaturesDto) => {
    try {
        const formData = new FormData();
        Object.keys(body).forEach(key => {
            if (key === 'image' && body?.image && !body.image?.path?.includes('http')) {
                formData.append('image', body.image, body.image.name)
            } else if (key === 'image' && !body.image?.path?.includes('http')) {
                formData.append('image', 'null')
            } else if (body[key] !== null && body[key] !== undefined) {
                formData.append(key, body[key].toString());
            }
        });
        const response = await featuresService.update(body.id, formData);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            toastService.onSuccess('Success');
            featuresModel.feature = response.data;
            await getFeaturesUseCase();
        }
        return response;
    } catch (error) {
        console.warn('updateFeaturesUseCase: ', error);
    }
}  